import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter);

export default new VueRouter({
    routes: [{
        name: "Login",
        path: "/Login",
        component: () =>
            import("../common/login/Login.vue")
    },
    {
        name: "Main",
        path: "/Main",
        component: () =>
            import("../Main.vue"),
        children: [
            {
                name: "BasicShare",
                path: "/BasicShare",
                component: () =>
                    import("../common/basic/BasicShare.vue"),
            },
            {
                name: "BasicNotice",
                path: "/BasicNotice",
                component: () =>
                    import("../common/basic/BasicNotice.vue"),
            },
            {
                name: "BasicParam",
                path: "/BasicParam",
                component: () =>
                    import("../common/basic/BasicParam.vue"),
            },
            {
                name: "BasicType1",
                path: "/BasicType1",
                component: () =>
                    import("../common/basic/BasicType1.vue"),
            },
            {
                name: "BasicType2",
                path: "/BasicType2",
                component: () =>
                    import("../common/basic/BasicType2.vue"),
            },
            {
                name: "LogDownLoad",
                path: "/LogDownLoad",
                component: () =>
                    import("../common/log/LogDownLoad.vue"),
            },
            {
                name: "LogException",
                path: "/LogException",
                component: () =>
                    import("../common/log/LogException.vue"),
            },
            {
                name: "LogJson",
                path: "/LogJson",
                component: () =>
                    import("../common/log/LogJson.vue"),
            },
            {
                name: "LogLogin",
                path: "/LogLogin",
                component: () =>
                    import("../common/log/LogLogin.vue"),
            },
            {
                name: "LogOperate",
                path: "/LogOperate",
                component: () =>
                    import("../common/log/LogOperate.vue"),
            },
            {
                name: "LogServer",
                path: "/LogServer",
                component: () =>
                    import("../common/log/LogServer.vue"),
            },
            {
                name: "LogApp",
                path: "/LogApp",
                component: () =>
                    import("../common/log/LogApp.vue"),
            },
            {
                name: "LogUpload",
                path: "/LogUpload",
                component: () =>
                    import("../common/log/LogUpload.vue"),
            },
            {
                name: "UserInfo",
                path: "/UserInfo",
                component: () =>
                    import("../common/user/UserInfo.vue"),
            },
            {
                name: "UserPage",
                path: "/UserPage",
                component: () =>
                    import("../common/user/UserPage.vue"),
            },
            {
                name: "UserRole",
                path: "/UserRole",
                component: () =>
                    import("../common/user/UserRole.vue"),
            }, {
                name: "UserOperate",
                path: "/UserOperate",
                component: () =>
                    import("../common/user/UserOperate.vue"),
            },
            {
                name: "UserDept",
                path: "/UserDept",
                component: () =>
                    import("../common/user/UserDept.vue"),
            },

            {
                name: "TourOpinion",
                path: "/TourOpinion",
                component: () =>
                    import("../pages/TourOpinion.vue"),
            },
            {
                name: "DeptManage",
                path: "/DeptManage",
                component: () =>
                    import("../pages/DeptManage.vue"),
            },
            {
                name: "TypeManage",
                path: "/TypeManage",
                component: () =>
                    import("../pages/TypeManage.vue"),
            },
            {
                name: "TourInfo",
                path: "/TourInfo",
                component: () =>
                    import("../pages/TourInfo.vue"),
            }
        ]
    },
    {
        path: '/',
        redirect: '/Login'
    }
    ]
});